import React from 'react';
import GpyComponent from './GpyComponent'

class GpyTime extends GpyComponent {


  constructor(props) {
      super(props);
      this.state = {
            gpyComponentID: super.getId(),
            connected: false,
            activeTimer: false,
            countdown : props.countdown!==undefined ? (props.countdown==="true"||props.countdown===true?true:false) :false,
            min : props.min!==undefined?parseInt(props.min):undefined,
            syncMode:false,
            remoteStart: false,
            startAt: Date.now(),
            offset:0,
            currentMin:0,
            currentSec:0,
      };
    }

    onChangeValue(o) {
      if ( o.offset !== undefined ) {
            var s = parseInt(o.offset,10);
            this.setState({offset: s},()=>{
                this.setStateOnServer(s);
                this.tick();
            });
      }
    }

    isActive() {
      return this.state.activeTimer;
    }

      componentDidMount() {
      if(this.props.scoreboard !== undefined ){
         this.props.scoreboard.registerComponent(this.props.stateName,this);
      };

      if(this.props.scoreboard.state !== undefined && this.props.stateName !== undefined) {
        if(this.props.scoreboard.state[this.props.stateName] !== undefined && this.props.scoreboard.state[this.props.stateName].offset !== undefined) {
            var millis = parseInt(this.props.scoreboard.state[this.props.stateName].offset,10)
            this.setState({offset :  Math.floor(millis) });
        }

      if(this.props.scoreboard.state[this.props.stateName] !== undefined && this.props.scoreboard.state[this.props.stateName].active !== undefined) {
          if(this.props.scoreboard.state[this.props.stateName].active) {
            this.setState({activeTimer : true,startAt:Date.now()});
            this.interval = setInterval(() => this.tick(), (50));
          }
        }
      }
      this.tick();
    }

    onData(key,data) {
      if(data.gpyComponentID !== this.state.gpyComponentID) {
              if(data.offset !== undefined) {

                    this.setState({offset : data.offset,startAt: Date.now()}, ()=>{
                      this.tick();

                      var a = (data.active === "true");
                      if(a !== this.state.activeTimer) {
                        if(a) {
                            this.setState({startAt: Date.now(),activeTimer: true, remoteStart: true},()=>{
                              this.props.scoreboard.forceUpdate();
                              this.forceUpdate();
                            });
                            this.interval = setInterval(() => this.tick(), (50));
                        } else {
                             this.setState({activeTimer: false, startAt: Date.now() },()=>{
                               this.props.scoreboard.forceUpdate();
                               this.forceUpdate();
                             });
                             clearInterval(this.interval);
                        }
                      }

                    });
          }
      }
    }

    changeOffset(val,callback){
            var offset = this.state.offset  + val ;
            if(this.state.min!==undefined) {
              if(offset<this.state.min) {
                offset=this.state.min;
              }
            }
            this.setState({offset: offset },()=>{
              if(callback!==undefined){
                this.setStateOnServer(offset,callback());
              } else {
                 this.setStateOnServer(offset);
              }

                this.tick();
            });
    }

    getSecond() {
          if(!this.state.activeTimer) {
            return this.state.offset;
          }
          var offset = this.state.offset;
          var startAt = this.state.startAt;

          var result = 0;
          result = Date.now() - startAt;
          if(this.state.countdown) {
            result =  (offset - result);
          } else {
            result =  (result + offset);
          }

          if(result < 0) {
              result = 0;
          }

          return result;
    }

    setStateOnServer(offset,callback) {
      super.setTimerOffset(this.props.stateName, offset, this.state.countdown,this.state.gpyComponentID,callback);
    }

    tick() {

      var m = this.state.currentMin;
      var s = this.state.currentSec;

      var second = this.getSecond();

      if(second <= 0) {
        if(this.props.onTimerNull!==undefined){
          this.props.onTimerNull(this);
        }
      }
      var minF = (parseInt(second)/1000) / 60 ;
      var minI = Math.floor(minF) ;
      var sec = Math.floor((minF-minI)*60);

      if(s!==sec || m!==minI) {
        this.setState({currentSec:sec,currentMin:minI});
      }
    }

    start(callback) {
        clearInterval(this.interval);
        this.setState({activeTimer: true, startAt:Date.now()}, () => {
          this.interval = setInterval(() => this.tick(), (50));
          super.startTimer(this.props.stateName,this.state.offset,this.state.countdown,this.state.gpyComponentID);
          if(callback!==undefined){
              callback();
          }
        });
    }

    setTimeTo(offset) {
      this.setState({offset:offset,startAt:Date.now()}, ()=>{
        this.tick();
        super.setTimerOffset(this.props.stateName , this.state.offset , this.state.countdown,this.state.gpyComponentID)
      });
    }

    startAt(offset) {
            clearInterval(this.interval);
            this.setState({activeTimer: true,offset:offset,startAt:Date.now()},()=>{
              this.interval = setInterval(() => this.tick(), (50));
              super.startTimer(this.props.stateName , this.state.offset , this.state.countdown,this.state.gpyComponentID);
            });
    }

    stop (callback) {
        if(callback===undefined){
          this.setState({activeTimer: false, startAt: Date.now(), offset:this.getSecond()});
        } else {
          this.setState({activeTimer: false, startAt: Date.now(), offset:this.getSecond()}, callback);
        }
        clearInterval(this.interval);
        super.stopTimer(this.props.stateName,this.state.gpyComponentID);
    }

   render() {
    if(this.props.hidden==="true") {return ("")}

    const {activeTimer} = this.state;

    var disabled = function(def,i){
      if(activeTimer){
        return def + " disabled"
      }
      return def;
    }
    var formatMin = ('000'+this.state.currentMin).slice(-3);
    var formatSec = ('00'+this.state.currentSec).slice(-2);

    return (
      <div className="row">
              <div className="col-6 text-left">
                    <div className="row p-0">
                      <div className="col-5 p-0 pl-1 text-right"><button className={disabled("btn btn-link btn-sm")} onClick={()=>this.changeOffset(-60000)}><span className="glyphicon glyphicon-minus" /></button></div>
                      <div className="col-2 p-0 pt-1 text-center">{formatMin}</div>
                      <div className="col-5 p-0 pr-1 text-left"><button className={disabled("btn btn-link btn-sm")} onClick={()=>this.changeOffset(60000)}><span className="glyphicon glyphicon-plus" /></button></div>
                    </div>
              </div>

              {/*<div className="col-2 text-center" style={{backgroundColor:"#aaa"}}>:</div>*/}

              <div className="col-6 text-right">
                <div className="row p-0">
                  <div className="col-5 p-0 pl-1 text-right"><button className={disabled("btn btn-link btn-sm")} onClick={()=>this.changeOffset(-1000)}><span className="glyphicon glyphicon-minus" /></button></div>
                  <div className="col-2 p-0 pt-1 text-center">{formatSec}</div>
                  <div className="col-5 p-0 pr-1 text-left"><button className={disabled("btn btn-link btn-sm")} onClick={()=>this.changeOffset(1000)}><span className="glyphicon glyphicon-plus" /></button></div>
               </div>

            </div>
      </div>
		)
  }
}
export default GpyTime;
